<template>
  <div v-if="scriptReady">
    <label v-if="getTitle" :for="sid">
      {{ getTitle }}
      <w-tooltip v-if="tooltipContent && tooltipContent.length">{{ tooltipContent }}</w-tooltip>
    </label>

    <vue-ckeditor
      :id="sid"
      ref="input"
      v-model="model.$value"
      :read-only-mode="disabled"
      :config="CKEditorConfig"
      @blur="onBlur"
      @focus="onFocus"
      @contentDom="onEditorReady"
    />

    <w-error :model="model" @focus="$refs.input.focus()" />
  </div>
</template>

<script>
import VueCkeditor from 'vue-ckeditor2';

import modelMixin from '../mixins/modelMixin';
import WError from './error.vue';
import WTooltip from './tooltip.vue';

// Wymaga importu CKEditor4 w projekcie, który ma z niego korzystać
export default {
  name: 'WWysiwyg',
  components: { WError, WTooltip, VueCkeditor },
  mixins: [modelMixin],
  vmodel: true,
  props: {
    // Domyślna wysokość
    height: {
      type: Number,
      required: false,
      default: 450
    },
    // Język edytora
    language: {
      type: String,
      required: false,
      default: 'pl'
    },
    // URL uploadu obrazków
    imageUploadUrl: {
      type: String,
      required: false,
      default: ''
    },
    // Konfiguracja CKEditora
    config: {
      type: Object,
      required: false,
      default: () => ({})
    },
    // Link do skryptu CKEditora
    // eslint-disable-next-line vue/prop-name-casing
    CKEditorScriptURL: {
      type: String,
      required: false,
      default: 'https://cdn.ckeditor.com/4.22.1/full/ckeditor.js'
    },
    contentCss: {
      type: [String, Array],
      required: false,
      default: () => ['https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css']
    }
  },
  data() {
    return {
      CKEditorConfig: {
        height: this.height,
        language: this.language,
        imageUploadUrl: this.imageUploadUrl,
        extraPlugins: 'forms',
        removePlugins: [
          'bidi',
          'templates',
          'indentblock',
          'elementspath',
          'save',
          'selectall',
          'newpage',
          'docprops',
          'preview',
          'print',
          'templates',
          'document',
          'find',
          'replace',
          'selectall',
          'scayt',
          'forms',
          'language',
          'anhor',
          'flash',
          'iframe',
          'smiley',
          'showblocks',
          'maximize',
          'magicline',
          'wsc'
        ],
        contentCss: this.contentCss,
        disableNativeSpellChecker: false,
        ...this.config
      },
      scriptReady: false,
      sid: 'wysiwyg' + Math.round(Math.random() * 1000000)
    };
  },
  created() {
    this.loadScript().then(() => {
      this.scriptReady = true;
    });
  },
  methods: {
    // @vuese
    // Załadowanie skryptu do obsługi CKEditora
    loadScript() {
      const scriptId = 'CKEditorScript';
      return new Promise((resolve, reject) => {
        const script = document.getElementById(scriptId);
        if (script) {
          return this.handleInsertedScript(script, resolve);
        }
        this.insertScript(scriptId, resolve);
      });
    },
    // @vuese
    // Obsługa załadowanego już skryptu
    handleInsertedScript(script, resolve) {
      if (script.hasAttribute('loaded')) {
        resolve();
      }
      const oldOnload = script.onload;
      script.onload = () => {
        oldOnload();
        resolve();
      };
    },
    // @vuese
    // Podpięcie skryptu do head
    insertScript(scriptId, resolve) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.type = 'text/javascript';
      script.src = this.CKEditorScriptURL;
      script.onload = () => {
        script.setAttribute('loaded', true);
        resolve();
      };
      document.getElementsByTagName('head')[0].appendChild(script);
    },
    onEditorReady(contentDom) {
      let arrayOfCss = this.contentCss;
      if (!Array.isArray(this.contentCss)) {
        arrayOfCss = [this.contentCss];
      }
      for (const css of arrayOfCss) {
        contentDom.editor.document.appendStyleSheet(css);
      }
    }
  }
};
</script>

<style>
.cke_notifications_area {
  display: none !important;
}
</style>
